// Iko category tokens — three ramps each (bright / deep / companion) per Brief Part 5.2.
export const IKO = {
  sherehe: { label: "Sherehe", desc: "Parties · Nightlife",       hex: "#FF6B9D", deep: "#D1257B", companion: "#8A3A5C" },
  polite:  { label: "Polite",  desc: "Arts · Culture · Wellness", hex: "#9D4EDD", deep: "#9946DC", companion: "#5B3A7A" },
  michezo: { label: "Michezo", desc: "Sports · Games",            hex: "#5390FF", deep: "#0E63FF", companion: "#31518C" },
  kazi:    { label: "Kazi",    desc: "Networking · Career",       hex: "#44DD88", deep: "#0E8148", companion: "#2C7150" },
};

export const KILI = "#FFD60A";
// Kili yellow permitted uses (priority order): score+roses, primary CTA, one integrity callout per page.
// Named exceptions (do NOT spend page yellow): logo centre dot, brand pattern artwork.
// FORBIDDEN: yellow on prices, yellow type on cream (1.29:1), yellow panels, yellow keylines, yellow body copy, yellow score numbers.

export const IKO_KEYS = Object.keys(IKO);

export function wordCount(s) {
  return (s || "").trim() ? (s || "").trim().split(/\s+/).length : 0;
}

// WW-162 (Vania 13 Oct 2026 · D-4 QA) · delegate to the shared Nairobi
// helper so a zoneless string is treated as EAT before formatting.
// Keeping this function name + signature so existing callers compile.
import { nairobiDate, NAIROBI_TZ } from "./datetime";
export function formatEAT(iso) {
  if (!iso) return "";
  const d = nairobiDate(iso);
  if (!d) return iso;
  return d.toLocaleString("en-GB", {
    timeZone: NAIROBI_TZ,
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

// Iko chip styling. NIGHT: bright hex does both jobs (fill + text).
// CREAM: bright FILLS ONLY; deep carries the words. Text on a bright fill is night ink #1A1A30.
export function chipStyle(ikoKey, { solid = false, ground = "cream" } = {}) {
  const t = IKO[ikoKey];
  if (!t) return { background: "transparent", color: "inherit", borderColor: "currentColor" };
  if (solid) {
    // On cream OR night, filled chip uses bright with night-ink text.
    return { background: t.hex, color: "#1A1A30", borderColor: t.hex };
  }
  // Outline / soft chip. Text = deep on cream, bright on night.
  const textColor = ground === "night" ? t.hex : t.deep;
  return { background: `${t.hex}22`, color: textColor, borderColor: `${t.hex}55` };
}

// Time-of-day tokens — Master Brief Part 0b: this is not a nightlife app.
export const TIME_OF_DAY = [
  { key: "morning",   label: "Morning",   startHr: 5,  endHr: 11 },
  { key: "afternoon", label: "Afternoon", startHr: 12, endHr: 16 },
  { key: "evening",   label: "Evening",   startHr: 17, endHr: 21 },
  { key: "late",      label: "Late",      startHr: 22, endHr: 4  },
];
export function timeOfDayFor(startAtIso) {
  if (!startAtIso) return null;
  const hr = new Date(startAtIso).getHours();
  if (hr >= 5 && hr <= 11)  return "morning";
  if (hr >= 12 && hr <= 16) return "afternoon";
  if (hr >= 17 && hr <= 21) return "evening";
  return "late";
}

// Brand-case normaliser — sweep helper.
export function toBrandCase(s, { preserveEyebrow = false } = {}) {
  if (!s) return s;
  if (preserveEyebrow && /^WATU WAKO\s*·\s*/.test(s)) return s;
  return s.replace(/watu\s*wako/gi, "watu wako");
}
